import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import OurStory from "@/pages/OurStory";

export const Route = createFileRoute("/es/sobre-qbd/historia")({
  head: () => buildRouteHead("/es/sobre-qbd/historia"),
  component: OurStory,
});

